import * as React from "react";
import { Button } from "ui/button";
import { cn } from "./utils";

const PopoverTriggerUI = React.forwardRef<
  React.ElementRef<typeof Button>,
  React.ComponentPropsWithoutRef<typeof Button>
>(({ className, ...props }, ref) => {
  return (
    <Button
      ref={ref}
      variant="ghost"
      className={cn(
        "border-none bg-transparent shadow-none",
        "!h-[23px] !min-h-0",
        "!px-0 !py-0",
        "text-sm leading-none",
        "flex items-center justify-between w-full",
        "focus:ring-0 focus:outline-none",
        className
      )}
      {...props}
    />
  );
});

PopoverTriggerUI.displayName = "PopoverTriggerUI";

export { PopoverTriggerUI };